import type { AtribuirBairrosModel } from "../models/atribuirBairrosModel"
import { AtribuirBairrosInicial } from "../models/atribuirBairrosModel"
import type { AtribuirBairrosActionModel } from "./atribuirBairrosActions"
import { AtribuirBairrosActionsTypes } from "./atribuirBairrosActions"

export function atribuirBairrosReducer(
    state: AtribuirBairrosModel,
    action: AtribuirBairrosActionModel
): AtribuirBairrosModel {
    switch (action.type) {
        case AtribuirBairrosActionsTypes.CARREGAR_DADOS:
            return {
                ...state,
                atendidos: action.payload.atendidos,
                naoAtendidos: action.payload.naoAtendidos,
                idsBairrosSelecionados: [],
                taxa: "",
                taxaNoturna: "",
                minimoEntregaGratis: "",
                taxaEntregador: "",
            }

        case AtribuirBairrosActionsTypes.CARREGAR_CIDADES_ESTABELECIMENTO:
            return { ...state, cidadesEstabelecimento: action.payload }

        case AtribuirBairrosActionsTypes.CARREGAR_TODAS_CIDADES:
            return { ...state, todasCidades: action.payload }

        case AtribuirBairrosActionsTypes.SELECIONAR_CIDADE:
            return {
                ...state,
                idCidadeSelecionada: action.payload,
                idsBairrosSelecionados: [],
            }

        case AtribuirBairrosActionsTypes.TOGGLE_BAIRRO: {
            const id = action.payload
            const jaEsta = state.idsBairrosSelecionados.includes(id)
            return {
                ...state,
                idsBairrosSelecionados: jaEsta
                    ? state.idsBairrosSelecionados.filter(i => i !== id)
                    : [...state.idsBairrosSelecionados, id],
            }
        }

        case AtribuirBairrosActionsTypes.TOGGLE_TODOS:
            return {
                ...state,
                idsBairrosSelecionados: action.payload
                    ? state.naoAtendidos.map(b => b.id)
                    : [],
            }

        case AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case AtribuirBairrosActionsTypes.ATUALIZAR_BAIRRO_ATENDIDO:
            return {
                ...state,
                atendidos: state.atendidos.map(b =>
                    b.id === action.payload.id ? action.payload : b
                ),
            }

        case AtribuirBairrosActionsTypes.REMOVER_BAIRRO_ATENDIDO:
            return {
                ...state,
                atendidos: state.atendidos.filter(b => b.id !== action.payload),
            }

        case AtribuirBairrosActionsTypes.LIMPAR_SELECAO:
            return { ...state, idsBairrosSelecionados: [] }

        default:
            return state
    }
}

export { AtribuirBairrosInicial }
